import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CpfCnpjService {

  /**
   * @name removeMask
   * @param {string} cpfCnpj cpf ou cnpf with mask
   * @returns {string} cpf or cnpj without mask
   * @description remove mask to cpf or cnpj
   */
  removeMask(cpfCnpj: string) {
    return cpfCnpj.replace(/[^\d]+/g,'');
  }

  /**
   * @name validateCpfCnpf
   * @param {string} cpfCnpj number of cpf or cnpf
   * @returns {boolean} if cpf or cnpj is valid
   * @description validates if it is cpf or cpf, and calls respective function to validate
   */
  validateCpfCnpj(cpfCnpj: string) {
    cpfCnpj = this.removeMask(cpfCnpj);

    if(cpfCnpj.length === 11) {
      return this.validateCpf(cpfCnpj);
    } else if(cpfCnpj.length === 14) {
      return this.validateCnpj(cpfCnpj);
    } else {
      return false;
    }
  }

  /**
   * @name validateCnpj
   * @param {string} cnpj
   * @returns {boolean} if the cnpj is valid
   * @description valid cnpj
   */
  validateCnpj(cnpj) {
    if (cnpj == "00000000000000" || cnpj == "11111111111111" || cnpj == "22222222222222" || cnpj == "33333333333333" || cnpj == "44444444444444" || cnpj == "55555555555555" || cnpj == "66666666666666" || cnpj == "77777777777777" || cnpj == "88888888888888" || cnpj == "99999999999999") return false;

    let size = cnpj.length - 2
    let numbers = cnpj.substring(0, size);
    let digits = cnpj.substring(size);
    let amout = 0;
    let pos = size - 7;

    for(let i = size; i >= 1; i--) {
      amout += numbers.charAt(size - i) * pos--;
      if (pos < 2) pos = 9;
    }

    let result = amout % 11 < 2 ? 0 : 11 - amout % 11;

    if (result != digits.charAt(0)) return false;

    size += 1;
    numbers = cnpj.substring(0,size);
    amout = 0;
    pos = size - 7;

    for(let i = size; i >= 1; i--) {
      amout += numbers.charAt(size - i) * pos--;
      if (pos < 2) pos = 9;
    }

    result = amout % 11 < 2 ? 0 : 11 - amout % 11;

    if (result != digits.charAt(1)) return false;

    return true;
  }

  /**
   * @name validateCpf
   * @param {string} cpf
   * @returns {boolean} if the cpf is valid
   * @description valid cpf
   */
  validateCpf(cpf: string) {
    let amout = 0;
    let rest;

    if (cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" || cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" || cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") return false;

    for (let i = 1; i <= 9; i++) {
      amout += parseInt(cpf.substring(i-1, i)) * (11 - i)
    };

    rest = (amout * 10) % 11;

    if ((rest == 10) || (rest == 11))  rest = 0;
    if (rest != parseInt(cpf.substring(9, 10)) ) return false;

    amout = 0;

    for (let i = 1; i <= 10; i++) {
      amout += parseInt(cpf.substring(i-1, i)) * (12 - i)
    };

    rest = (amout * 10) % 11;

    if ((rest == 10) || (rest == 11))  rest = 0;
    if (rest != parseInt(cpf.substring(10, 11) ) ) return false;

    return true;
  }
}
